import { ApiaUtil } from '@apia/components';
import { makeObservable, observable, action } from 'mobx';

export class CameraController {
  state: {
    videoStream: MediaStream | null;
    isOpen: boolean;
  } = {
    videoStream: null,
    isOpen: false,
  };
  private currentCapture: File | null = null;

  private videoElement: HTMLVideoElement;

  constructor() {
    makeObservable(this, {
      state: observable,
      openCamera: action,
      closeCamera: action,
    });

    this.videoElement = document.createElement('video');
    this.videoElement.autoplay = true;
    this.videoElement.playsInline = true;
  }

  async openCamera() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      this.state.videoStream = stream;
      this.videoElement.srcObject = stream;
      this.state.isOpen = true;
      ApiaUtil.instance.modals.open({
        children: <this.Component></this.Component>,
        onConfirm: () => {
          this.closeCamera();
        },
        onClose: () => {
          this.closeCamera();
        },
      });
    } catch (error) {
      console.error('Error while accessing the camera:', error);
      this.state.isOpen = false;
      this.closeCamera();
    }
  }

  async closeCamera() {
    if (!this.videoElement.srcObject) return;

    const canvas = document.createElement('canvas');
    canvas.width = this.videoElement.videoWidth;
    canvas.height = this.videoElement.videoHeight;
    const ctx = canvas.getContext('2d');
    if (ctx)
      ctx.drawImage(this.videoElement, 0, 0, canvas.width, canvas.height);

    this.currentCapture = await new Promise<File | null>((resolve) => {
      canvas.toBlob((blob: Blob | null) => {
        if (blob) {
          const file = new File([blob], 'captured_image.jpg', {
            type: 'image/jpeg',
          });
          resolve(file);
        } else {
          this.closeCamera();
        }
      }, 'image/jpeg');
    }).finally(() => {
      this.state.videoStream?.getTracks().forEach((track) => track.stop());
      this.state.videoStream = null;
      this.videoElement.srcObject = null;
      this.state.isOpen = false;
    });
  }

  pop() {
    const returnFile = this.currentCapture;
    this.currentCapture = null;
    return returnFile;
  }

  Component = () => {
    return (
      <video
        ref={(el) => {
          if (el) {
            el.srcObject = this.videoElement.srcObject;
            el.autoplay = true;
            el.playsInline = true;
          }
        }}
        style={{ width: '100%', height: 'auto' }}
      />
    );
  };
}
